module.exports = __webpack_public_path__ + "img/km.afc10f1d.svg";